import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_DOCUMENTTEMPLATE } from "../../../../utils/constants";
import { DocumentTemplateInterface } from "../../../../models/ProcurementModule/DocumentTemplate";
import ToastMessage from "../../../../common/ToastMessage";
import documentTemplateService from "../../../../services/general/documentTemplateService";

interface DeleteDataContext {
  previousDocumentTemplates: DocumentTemplateInterface[];
  deletedDocumentTemplate: DocumentTemplateInterface | undefined;
}

const useDeleteDocumentTemplate = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string, DeleteDataContext>({
    mutationFn: documentTemplateService.Remove,

    onMutate: (dataId: string) => {
      const previousDocumentTemplates =
        queryClient.getQueryData<DocumentTemplateInterface[]>([
          CACHE_KEY_DOCUMENTTEMPLATE,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      queryClient.setQueryData<DocumentTemplateInterface[]>(
        [
          CACHE_KEY_DOCUMENTTEMPLATE,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        previousDocumentTemplates.filter((data) => data.id !== dataId) // Use companyId to filter
      );

      ToastMessage.Success();
      return {
        previousDocumentTemplates,
        deletedDocumentTemplate: previousDocumentTemplates.find(
          (data) => data.id === dataId
        ),
      };
    },

    onError: (error, dataId, context) => {
      ToastMessage.Failed(error.message);
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<DocumentTemplateInterface[]>(
        [
          CACHE_KEY_DOCUMENTTEMPLATE,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousDocumentTemplates
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteDocumentTemplate;
